// extracted by mini-css-extract-plugin
module.exports = {"copy":"aegisubNamesModal_copy__D4sPi","textarea":"aegisubNamesModal_textarea__2s6zz","fieldsBeforeText":"aegisubNamesModal_fieldsBeforeText__2GPCv"};